<div class="pagination">
    <ul class="paginationMenu" *ngIf="page.totalPages>1">
        <li class="pagination-previous" [class.disabled]="page.first">
            <a [attr.aria-disabled]="page.first" (click)="first()" [attr.aria-label]="i18n.backTitle" title="{{i18n.backTitle}}">
                <button type="button" ibtn="allback" ibtnSmall ibtnUnboxed></button>
            </a>
        </li>
        <li class="pagination-previous" [class.disabled]="page.first">
            <a [attr.aria-disabled]="page.first" (click)="previous()" [attr.aria-label]="i18n.backTitle" title="{{i18n.backTitle}}">
                <button type="button" ibtn="back" ibtnSmall ibtnUnboxed></button>
            </a>
        </li>
        <li *ngFor="let pag of pageArray">
            <a (click)="setCurrent(pag.value -1)" [class.current]="getCurrent()+1 === pag.value">
                <span>{{ pag.label }}</span>
            </a>
        </li>
        <li class="pagination-next" [class.disabled]="page.last">
            <a [attr.aria-disabled]="page.last" (click)="next()" [attr.aria-label]="i18n.nextTitle" title="{{i18n.nextTitle}}">
                <button type="button" ibtn="forward" ibtnSmall ibtnUnboxed></button>
            </a>
        </li>
        <li class="pagination-next" [class.disabled]="page.last">
            <a [attr.aria-disabled]="page.last" (click)="last()" [attr.aria-label]="i18n.nextTitle" title="{{i18n.nextTitle}}">
                <button type="button" ibtn="allforward" ibtnSmall ibtnUnboxed></button>
            </a>
        </li>
        <li *ngIf="showPageSize">
            <common-form-input [ngModel]="page.size" class="smal" [items]="i18n.pageSize" disableReset="true"
                               (isSelected)="onChange($event)" type="select" ngDefaultControl></common-form-input>
        </li>
    </ul>
    <ul class="paginationMenu" *ngIf="page.totalPages==1 && showPageSize">
        <li>
            <common-form-input [(ngModel)]="page.size" [items]="i18n.pageSize" class="smal" disableReset="true"
                               (isSelected)="onChange($event)" type="select" ngDefaultControl></common-form-input>
        </li>
    </ul>
</div>
